export default {
    state: {
        promozioni: [{
            text: "I dati sono trattati per fornire offerte, promozioni e soluzioni innovative e personalizzate, migliorando il livello di protezione. Il trattamento dei dati è facoltativo e possibile solo con il consenso dell’interessato liberamente revocabile.",
        }],
    }
}